export default ({palette}) => ({
    subtitle: {
        flexGrow: 1,
        fontSize: "1.2rem",
        color: palette.subtitle
    }
})